var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-8 pb-4 text-center lg:pb-0 lg:text-left"},[_c('h1',[_vm._v(_vm._s(_vm.pageTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }